<template>
  <div class="wrapper__rules">
    <div
        :class="{
            'wrapper__rules__container animated': true,
            'bounceInDown': show,
            'bounceOutUp': !show
        }"
    >
        <a
            class="wrapper__rules__container__logo"
            :href="exits.lunchables"
            target="_blank"
            v-trackevent:val="'rules-logo'"
        >
            <img src="images/logo.png" alt="Lunchables"/>
        </a>
       <div class="wrapper__rules__legal">
            <perfect-scrollbar ref="scrollbar">
                <div class="wrapper__rules__scrollable">
                    <h2 class="wrapper__rules__title">
                        CONTEST OFFICIAL RULES
                    </h2>
                    <p class="wrapper__rules__text" v-html="rules"></p>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
  </div>
</template>

<script>
    import CONFIG from '@/config';

    export default {

        name: 'Rules',

        props: ['rules'],

        data() {

            return {
                show: true,
                exits: {
                    lunchables: CONFIG.settings.exits.lunchables
                }
            };
        }
    }
</script>

<style scoped lang="scss">
    .wrapper__rules {
        position: relative;
        height: 100%;
        width: 100%;

        &__container {
            margin: 0px auto;
            text-align: center;
            max-width: 1000px;
            height: 100%;

            &__logo {
                display: block;
                margin: 6px auto 0px auto;
            }
        }

        &__legal {
            height: calc(100% - 118px - 50px - 30px);
            width: 90%;
            margin: 50px auto 30px auto;

            .ps {
                height: 100%;
            }
        }

        &__title {
            color: #a4252a;
            font-family: 'Bungee', cursive;
            font-size: 34px;
            padding-bottom: 30px;
        }

        &__text {
            color: #a4252a;
            font-family: 'Open Sans', sans-serif;
            font-size: 16px;
        }
    }
</style>
